import { Params } from '@angular/router'
import { titleCase } from '../../util'
import { ApiResult } from '../remote-data'

export type ResourceType = 'Courthouse' | 'Courtroom' | 'Department'

export interface ResourceSettingsTabItem {
  label: string
  value: string
  routerUrl: string[]
  routerParams?: Params
}

export interface ResourceSettingsTabItemGroup {
  label: string
  tabs: ResourceSettingsTabItem[]
}

export type ResourceSettingsTabDefinition = (ResourceSettingsTabItemGroup | ResourceSettingsTabItem)[]

export interface ResourceSettingsViewModelKey {
  courtSystemId: string
  resourceId?: string
  parentResourceId?: string
  resourceType?: ResourceType
}

export interface ResourceSettingsKey extends ResourceSettingsViewModelKey {
  selectedTab: string
}

export interface ResourceSettingsLayoutViewModel {
  title: string
  subtitle?: string
  tabs: ResourceSettingsTabDefinition
}

export abstract class ResourceSettingsLayoutService {
  abstract buildViewModel(resourceKey: ResourceSettingsViewModelKey): ApiResult<ResourceSettingsLayoutViewModel>
}

export function formatSettingsTabLabel(tab: string): string {
  return titleCase(tab.replaceAll('-', ' '))
}

export function areResourceSettingsViewModelKeysEqual(
  a: ResourceSettingsViewModelKey,
  b: ResourceSettingsViewModelKey,
): boolean {
  return (
    a.courtSystemId === b.courtSystemId &&
    a.resourceId === b.resourceId &&
    a.parentResourceId === b.parentResourceId &&
    a.resourceType === b.resourceType
  )
}
